// extracted by mini-css-extract-plugin
export default {"outerContainer":"binform_outerContainer__jYn+M","selectOuterContainer":"binform_selectOuterContainer__MRnAw"};